export const PARISH_THRESHOLD = 13;
export const COUNTY_THRESHOLD = 10;
export const DISTRICT_THRESHOLD = 8;

export const FLYTO_OFFSET_SINGLE_FULLMAP = -100;
export const FLYTO_OFFSET_SINGLE = 170;
export const FLYTO_OFFSET_CLUSTER_MOBILE = 150;
export const FLYTO_OFFSET_CLUSTER = 275;

export enum DesiredLevel {
  District = "distrito",
  County = "concelho",
  Parish = "freguesia",
  RealEstate = "realEstate",
}

export const thresholdForDesiredLevel: Record<DesiredLevel, number> = {
  [DesiredLevel.District]: 12,
  [DesiredLevel.County]: 14,
  [DesiredLevel.Parish]: 17,
  [DesiredLevel.RealEstate]: 18,
};
